import React, {useEffect, useState} from 'react';
import './style.scss';
import {Popup} from '../../../../components';
import popupTaskQRBannerTv from '../../../../../images/popup-task-qr-banner-tv.png';
import { telegramMock } from 'telegram.consts';

const webApp = window.Telegram.WebApp;

const getStartParamFromQR = text => {
  let url;
  try {
    url = new URL(text);
  } catch (e) {
    url = null;
  }
  // t.me
  if (
      null !== url
      && url.host === 't.me'
      && url.searchParams.get('startapp')
  ) {
    const startParam = url.searchParams.get('startapp');
    if (
        startParam.substring(0, 2) === 'qr'
        && startParam.length >= 6
    ) {
      return startParam;
    }
  }
  if (
      null !== url
      && url.host === 'qrcods.ru'
  ) {
    switch (url.pathname) {
      case '/tv3-ladybug_bot': return 'qrkNl8';
      case '/tv3-ladybug_bot_qrVxW8': return 'qrVxW8';
      case '/tv3-ladybug_bot_qrVMgB': return 'qrVMgB';
      case '/tv3-ladybug_bot_qrV7lk': return 'qrV7lk';
      case '/tv3-ladybug_bot_qrV6PB': return 'qrV6PB';
      case '/tv3-ladybug_bot_qrk1RB': return 'qrk1RB';
      case '/tv3-ladybug_bot_qrBREk': return 'qrBREk';
      case '/tv3-ladybug_bot_qrBaKV': return 'qrBaKV';
      case '/tv3-ladybug_bot_qrB3oB': return 'qrB3oB';
      case '/tv3-ladybug_bot_qr8AxB': return 'qr8AxB';
    }
  }

  return null;
}

export const PopupTaskQR = ({onQrRead, onClose}) => {
  const [buttonText, setButtonText] = useState('Понятно');
  const [error, setError] = useState(false);

  const scanQR = () => {
    if (webApp.isVersionAtLeast('6.4')) {
      webApp.showScanQrPopup({text: 'Cканируй код в эфире ТВ-3'}, text => {
        const startParam = getStartParamFromQR(text);
        if (null !== startParam) {
          console.log('[Ladybug.QR] > startParam: ' + startParam);
          setError(false);
          onQrRead(startParam);
        } else {
          setError(true);
        }

        return true;
      });
    } else {
      onClose();
    }
  }

  useEffect(() => {
    if (webApp.isVersionAtLeast('6.4')) {
      setButtonText('Сканировать QR код');
    }
  }, []);

  return <Popup
      title="Сканируй QR-код в эфире"
      buttonText={buttonText}
      onButtonClick={() => scanQR()}
      onClose={onClose}
  >
    <img src={popupTaskQRBannerTv} alt="" className="app-popup-task-qr--tv"/>
    <div className="app-popup--description">
      28 сентября в&nbsp;течение дня в&nbsp;эфире&nbsp;ТВ-3 будут появляться плашки с&nbsp;QR-кодами. Сканируй их&nbsp;камерой смартфона и&nbsp;получай +<strong><span>5000&nbsp;баллов</span></strong> за&nbsp;каждый&nbsp;код
    </div>
    {error && <div className="app-popup-task-qr--error">Ой, это неверный QR-код ;(<br/> Попробуй еще раз!</div>}
  </Popup>;
}